var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.makePageFullScreen())},[_c('div',{style:(_vm.placeAtTheCenter())},[_c('h1',[_vm._v("This device is not compatible with our software")])])])}
var staticRenderFns = []

export { render, staticRenderFns }